export default __webpack_public_path__ + "static/media/Creditas.ee51a68e.png";